import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect, useLocation} from 'react-router-dom';
import {Dimmer, Loader} from 'semantic-ui-react';

import httpClient from 'httpClient';
import {login} from 'state/actions';
import {getToken} from 'state/selectors';

export default function LoginCallback() {
  const {search} = useLocation();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(getToken);

  const userLocation = localStorage.getItem('location');
  const [loginError, setLoginError] = useState(false);

  useEffect(() => {
    (async function() {
      // we don't want to perform authentication if required query parameters are not present
      const params = new URLSearchParams(search.slice(1));

      if (!search || !params.has('code')) {
        return;
      }

      try {
        const {
          status,
          data: {token, user},
        } = await httpClient.get('/authenticate', {params});
        if (status === 200) {
          dispatch(login(token, user));
        }
      } catch {
        setLoginError(true);
      }
    })();

    return () => {
      // make sure we don't leave the location in the localStorage once the user logs in
      localStorage.removeItem('location');
    };
  }, [dispatch, search]);

  if (loginError) {
    return <Redirect to="/" />;
  } else if (isAuthenticated || !search) {
    // Redirect to the initial path within the application, which triggered user authentication
    return <Redirect to={userLocation ? userLocation : '/'} />;
  } else {
    return (
      <Dimmer active>
        <Loader>Logging in</Loader>
      </Dimmer>
    );
  }
}
